import { buildClarityWorkspaceUrl } from './build-clarity-workspace-url.util';
import {
	appendClarityPathSegment,
	readClarityWorkspaceRoute,
	toClaritySectionUrl,
	toNavigationUnlessCurrent,
} from './clarity-workspace-route.util';
import { CLARITY_OPEN_ITEMS_ROUTE_SEGMENT } from './constants/clarity-open-items-route.constant';
import type { ClarityWorkspaceNavigation } from './models/clarity-workspace-navigation.model';
import { parseClarityWorkspaceLocation } from './parse-clarity-workspace-location.util';

/** Ported from Clarity `apps/web/src/shared/hooks/useWorkspaceRoute.ts` (commit `9015ce88c`). */
/**
 * Opening one open item — brain's `openOi(oiNumber)`: a **replace** to the current domain's Open Items
 * tab that drops `doc`, `page`, `file`, `oi` and `action`, carries every other query key verbatim, and is
 * `null` — no navigation — when that URL is `currentUrl` (their TR-014), or when the URL names no domain.
 *
 * Only the integration is adapted: the item is a path segment under the tab (`open-items/<oiSequence>`)
 * where brain writes `?oi=`, the current URL is an argument read at call time, the answer sits under
 * `sectionPath`, and the navigation is handed back rather than performed.
 */
export function toClarityOpenItemNavigation(
	currentUrl: string,
	sectionPath: string,
	oiSequence: number,
): ClarityWorkspaceNavigation | null {
	const current = readClarityWorkspaceRoute(currentUrl, sectionPath);
	const { domainId } = parseClarityWorkspaceLocation(current.params, current.search);

	if (domainId === null) {
		return null;
	}

	const tabUrl = buildClarityWorkspaceUrl(
		{
			domainId,
			tab: CLARITY_OPEN_ITEMS_ROUTE_SEGMENT,
			doc: null,
			page: null,
			file: null,
			oi: null,
			action: null,
		},
		current.search,
	);
	const url = appendClarityPathSegment(tabUrl, String(oiSequence));

	return toNavigationUnlessCurrent(current, toClaritySectionUrl(sectionPath, url), true);
}
